import script from "./TrustBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TrustBar.vue?vue&type=script&setup=true&lang=js"

import "./TrustBar.vue?vue&type=style&index=0&id=4c8459ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c8459ad"]])

export default __exports__